import {
  type EdgeId,
  type NodeData,
  type PathLookupEdgeData,
  isPathLookupEdgeData,
} from '@ipfabric/utils';
import type {
  DeviceViewEntity,
  DeviceViewNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewModel } from 'components/DeviceView/model/DeviceViewModel';
import type { GraphData } from 'components/Graph/model/GraphData';

export const getPathInspectorTabToResetData = (
  edgeId: EdgeId,
  edgeSource: 'source' | 'target',
  graph: GraphData,
  deviceView: DeviceViewModel,
): {
  currentEdge?: PathLookupEdgeData;
  followingNode?: NodeData;
  currentDeviceViewEntity?: DeviceViewNodeEntity;
} => {
  const currentEdge = graph.edges[edgeId];
  if (currentEdge === undefined || !isPathLookupEdgeData(currentEdge)) {
    return {};
  }

  // const graphNodes = selectNodesStableData(props.graph);
  const followingNode = graph.nodes[currentEdge[edgeSource]];
  if (followingNode === undefined) {
    return {};
  }

  const currentDeviceViewEntity = deviceView.deviceViewEntities.find(
    (entity: DeviceViewEntity): entity is DeviceViewNodeEntity =>
      entity.deviceViewElement === 'node' && entity.sn === followingNode.sn,
  );

  return {
    currentDeviceViewEntity,
    currentEdge,
    followingNode,
  };
};
